import { AgentSubscriber, Message } from "@ag-ui/client";
import { Fields } from "app/types-shared";

export type Role = "user" | "assistant";
export interface AiChatAssistantState {
  running: boolean;
  previousError?: string;
  hasConfirmedDraft: boolean;
  draftError?: string;
  createDraft?: boolean;
}

export const INITIAL_STATE: AiChatAssistantState = {
  running: false,
  previousError: undefined,
  hasConfirmedDraft: false,
  draftError: undefined,
  createDraft: false
};

export interface RunAgUiArgs {
  tenant: string;
  context: string;
  threadId: string;
  messages: Message[];
  subscriber: AgentSubscriber;
  abortController?: AbortController;
}

export interface SubscriberParams {
  event?: any;
  error?: { message?: string };
  [key: string]: any;
}

export interface ChatMessage {
  id: string;
  role: Role;
  content: string;
}

export interface AiChatAssistantProps {
  endpoint?: string;
  tenant?: string;
  token?: string;
  contextValue?: string;
}

export interface CaseDraftPayload {
  fields?: Fields,
  caseType: {
    v: number;
  };
}

export interface CaseDraftParameter { DataTag: string; Value: string | number | Array<string | number> }

export enum AiChatAssistantRole {
  User = "user",
  Assistant = "assistant"
}

export type CaseDraftSnapShot = {
  CaseDraft?: CaseDraftPayload;
  UserConfirmed?: boolean;
};
